/* global React, Icon, Card, CardHead, Button, IconButton, Field, Input, Select, Currency, Switch, Segmented, Tabs, Badge, StatusBadge, KPI, Modal, EmptyState, Pagination, FilterPanel, makeFilter, dateInFilter, toast, SectionTitle, INVOICES, CUSTOMERS, SUPPLIERS, PRODUCTS, DataList, fmt, fmt0, PlummeProductImportExport */
// Product helpers needed outside the products route: invoice control (productDefaultSalesAccount)
// and ProductModal (product-modal.jsx). Loaded eagerly; products.jsx stays route-lazy.
const productVatOptions = () => PlummeProductImportExport.vatOptions();
const productVatMeta = (value) => PlummeProductImportExport.vatMeta(value);
const productVatSelection = (product) => PlummeProductImportExport.vatSelection(product);
const productRentalPricing = (product) => window.PlummeRentalPricing?.normalizeRentalPricing?.(product?.rentalPricing) || { enabled: false, dayRates: [] };
const productTagsToText = (tags) => Array.isArray(tags) ? tags.filter(Boolean).join(', ') : String(tags || '');
const productTagsFromText = (text) => String(text || '').split(/[;,]/).map((tag) => tag.trim()).filter(Boolean);
const productDefaultSalesAccount = (vatSelection, type = 'Vare') => {
  const vat = productVatMeta(vatSelection);
  if (vat.treatment === 'exempt') return '3200';
  if (['salesReverseCharge51', 'export52', 'zeroRated'].includes(vat.treatment)) return '3100';
  if (vat.treatment === 'standard') {
    if (Number(vat.rate) === 15) return '3030';
    if (Number(vat.rate) === 12) return '3050';
    return type === 'Tjeneste' ? '3020' : '3000';
  }
  return type === 'Tjeneste' ? '3020' : '3000';
};
const productAccountCode = (value) => String(value || '').replace(/\D/g, '').slice(0, 5);
const productChartAccounts = () => {
  const model = window.PlummeBackend?.getChartAccountsModel?.() || [];
  return (Array.isArray(model) ? model : (model.standardAccounts || model.accounts || []))
    .filter((account) => account && account.active !== false)
    .map((account) => ({
      code: String(account.code || account.accountNumber || account.nr || '').trim(),
      name: account.name || account.label || t('prd.accountFallbackName'),
      custom: account.custom === true || account.locked === false,
      equivalentCode: account.equivalentCode || account.yearClosingStandardAccountCode || account.standardAccountCode || account.mapsToAccountCode || '',
    }))
    .filter((account) => account.code);
};
const productIncomeAccounts = () => {
  const accounts = productChartAccounts().filter((account) => account.code.startsWith('3'));
  return accounts.length ? accounts : [
    { code: '3000', name: t('prd.acct3000') },
    { code: '3020', name: t('prd.acct3020') },
    { code: '3030', name: t('prd.acct3030') },
    { code: '3050', name: t('prd.acct3050') },
    { code: '3100', name: t('prd.acct3100') },
    { code: '3200', name: t('prd.acct3200') },
    { code: '3900', name: t('prd.acct3900') },
  ];
};
const productStandardIncomeAccounts = () => productIncomeAccounts().filter((account) => !account.custom && /^\d{4}$/.test(account.code));
const productAccountLabel = (code) => {
  const account = productIncomeAccounts().find((entry) => entry.code === String(code || ''));
  return account ? `${account.code} ${account.name}` : String(code || '');
};
